import React, { Component } from 'react';
import { Slide } from 'react-slideshow-image';
import properties from '../../../modules/ajio-util/properties';
import { getImageNameForGTMPromotion } from '../../../modules/ga/gtmLandingPageMethods';
import BannerWrapper from '../../BannerWrapper';
import { replaceWithJioCDN } from '../../../utils/imageHandling';


class RotatingImagesComponent extends Component {
  componentDidMount() {
    let { pagedetails: { timeOut = 0, bannerImageDetails = [] } = {} } = this.props;

    let carousel = document.querySelectorAll('#rotatedImageComponent .indicators button');
    carousel.length > 1 &&
      carousel.forEach(node => {
        node.style.width = `${Math.floor(window.innerWidth / bannerImageDetails.length)}px`;
      });
  }

  render() {
    if (
      navigator.userAgent.indexOf('MSIE') != -1 ||
      navigator.userAgent.indexOf('Edge') != -1 ||
      navigator.userAgent.indexOf('Trident') != -1
    ) {
      console.log('Inside IE');
      let {
        pagedetails: { typeCode = '', timeOut = 0, bannerImageDetails = [], classes = '' } = {}
      } = this.props;
      if (bannerImageDetails.length > 1) {
        for (let i = bannerImageDetails.length; i > 1; i--) {
          bannerImageDetails.pop();
        }
      }
      return (
        <div>
          {bannerImageDetails.map((image, index) => {
            let {
              uId = '',
              bannerUrlLink = '',
              imageUrl = '',
              componentPosition = '',
              bannerPosition = ''
            } = image;
            const updatedImageUrl = replaceWithJioCDN(imageUrl);
            return (
              <a
                href={bannerUrlLink}
                key={imageUrl.toString()}
                data-ga-event-category="bannerTap"
                data-ga-event-action={`${typeCode}/${componentPosition}`}
                data-ga-event-label={`${bannerUrlLink}/${bannerPosition}`}
                data-gtm-bnr-position={`${componentPosition}`}
                data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(imageUrl) || ''}`}
                data-gtm-bnr-id={`${uId || ''}`}
              >
                <img src={updatedImageUrl} className="" />
              </a>
            );
          })}
        </div>
      );
    } else {
      let {
        pagedetails: { typeCode = '', timeOut = 0, bannerImageDetails = [], classes = '' } = {}
      } = this.props;
      let settings = {
        arrows: false,
        autoplay: false
      };
      if (bannerImageDetails.length > 1) {
        settings = {
          ...settings,
          duration: timeOut * 1000,
          transitionDuration: timeOut * 100,
          infinite: true,
          indicators: true,
          autoplay: true,
          canSwipe: false,
          pauseOnHover: false,
          stopOnInteraction: false 
        };
      }

      return (
        <div id="rotatedImageComponent">
          <style
            dangerouslySetInnerHTML={{
              __html: [
                '#rotatedImageComponent .indicators button.active::before {',
                `animation: backgroundLinera ${timeOut}s linear  !important`,
                '}'
              ].join('\n')
            }}
          />
          <Slide {...settings}>
            {bannerImageDetails.map((image, index) => {
              let {
                uId = '',
                bannerUrlLink = '',
                imageUrl = '',
                componentPosition = '',
                bannerPosition = ''
              } = image;
              const updatedImageUrl = replaceWithJioCDN(imageUrl);
              return (
                <a
                  href={bannerUrlLink}
                  key={updatedImageUrl.toString()}
                  data-ga-event-category="bannerTap"
                  data-ga-event-action={`${typeCode}/${componentPosition}`}
                  data-ga-event-label={`${bannerUrlLink}/${bannerPosition}`}
                  data-gtm-bnr-position={`${componentPosition}`}
                  data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(updatedImageUrl) || ''}`}
                  data-gtm-bnr-id={`${uId || ''}`}
                >
                  <img src={updatedImageUrl} className="" />
                </a>
              );
            })}
          </Slide>
        </div>
      );
    }
  }
}

export default BannerWrapper(RotatingImagesComponent);
